import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import Loading from './components/Loading';
import LeftPanel from './components/LeftPanel';
import MapArea from './components/MapArea';
import RightPanel from './components/RightPanel';
import ExhibitorList from './components/ExhibitorList';
import MyFavourites from './components/MyFavourites';
import ExhibitionInfo from './components/ExhibitionInfo';
import ExhibitorInfo from './components/ExhibitorInfo';
import './sass/index.sass';
import useData from './hooks/useData';
import ExhibitorListPrint from './components/ExhibitorListPrint';
import SearchPanel from './components/SearchPanel';
import useApp from './hooks/useApp';
import useUI from './hooks/useUI';

const currentUrl = window.location.href;
const root = ReactDOM.createRoot(document.getElementById('root'));
let className = '';

const MultiFloor = () => {
	const { floorInfo } = useData();

	const filteredFloorInfo = useMemo(() => {
		return floorInfo.filter((floor) => {
			return floor.floor !== '';
		});
	}, [floorInfo]);

	useEffect(() => {
		document.body.style.overflow = 'auto';
		document.documentElement.style.overflow = 'auto';

		setTimeout(() => {
			window.print();
		}, 5000);
	}, []);

	return (
		<div id='App' className='multi-floor' >
			{filteredFloorInfo.map((floor, index) => {
				return (
					<MapArea isPrint floor={floor} key={`map${index}`} />
				);
			})}
		</div>
	);
};

const urlParams = new URLSearchParams(window.location.search);
const Location = urlParams.get('location');
const Start = urlParams.get('start');
const booth = urlParams.get('booth');

if (Location) localStorage.setItem('Location', Location);
if (Start) localStorage.setItem('Start', Start);

const AppWrapper = () => {
	const { exhibitorInfo, floorInfo } = useData();
	const { setActiveFloor, setSelectedBooth, setSelectedExhibitor } = useApp();
	const { openExhibitorInfo } = useUI();

	useEffect(() => {
		if (booth) {
			const upperCaseBooth = booth.toUpperCase();
			const boothInfo = exhibitorInfo.find((exhibitor) => exhibitor['攤位號碼'] === upperCaseBooth);
			if (boothInfo) {
				const floor = boothInfo.floor;
				setActiveFloor(floor);
				setSelectedBooth(upperCaseBooth);
				setSelectedExhibitor(upperCaseBooth);
				openExhibitorInfo();
			}
		}
	}, [exhibitorInfo, floorInfo, setActiveFloor, setSelectedBooth, setSelectedExhibitor, openExhibitorInfo]);

	return (
		<div id='App' className={className}>
			<LeftPanel />
			<MapArea />
			<RightPanel />
			<ExhibitorList />
			<MyFavourites />
			<ExhibitionInfo />
			<ExhibitorInfo />
			<SearchPanel />
			<Loading />
		</div>
	);
}

if (currentUrl.includes('single-floor')) {
	root.render(
		<div id='App' className='single-floor'>
			<MapArea isPrint />
			<Loading />
		</div>
	);
}

else if (currentUrl.includes('multi-floor')) {
	root.render(<MultiFloor />);
}

else if (currentUrl.includes('exhibitor-list')) {
	root.render(<ExhibitorListPrint />);
}

else {
	root.render(
		<div id='App' className={className}>
			<AppWrapper />
		</div>
	);
}



